"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WaterImportFromEuropa = void 0;
const Tags_1 = require("../Tags");
const Card_1 = require("../Card");
const CardType_1 = require("../CardType");
const constants_1 = require("../../constants");
const CardName_1 = require("../../CardName");
const PartyHooks_1 = require("../../turmoil/parties/PartyHooks");
const PartyName_1 = require("../../turmoil/parties/PartyName");
const PlaceOceanTile_1 = require("../../deferredActions/PlaceOceanTile");
const SelectHowToPayDeferred_1 = require("../../deferredActions/SelectHowToPayDeferred");
const CardRenderer_1 = require("../render/CardRenderer");
const CardRenderDynamicVictoryPoints_1 = require("../render/CardRenderDynamicVictoryPoints");
const RedsPolicy_1 = require("../../turmoil/RedsPolicy");
const Units_1 = require("../../Units");
class WaterImportFromEuropa extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.ACTIVE,
            name: CardName_1.CardName.WATER_IMPORT_FROM_EUROPA,
            tags: [Tags_1.Tags.JOVIAN, Tags_1.Tags.SPACE],
            cost: 25,
            metadata: {
                cardNumber: '012',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.action('Pay 12 M€ to place an ocean tile. TITANIUM MAY BE USED as if playing a Space card.', (eb) => {
                        eb.megacredits(12).titanium(1).brackets.startAction.oceans(1);
                    }).br;
                    b.vpText('1 VP for each Jovian tag you have.');
                }),
                victoryPoints: CardRenderDynamicVictoryPoints_1.CardRenderDynamicVictoryPoints.jovians(1, 1),
            },
        });
    }
    getVictoryPoints(player) {
        return player.getTagCount(Tags_1.Tags.JOVIAN, 'raw');
    }
    play() {
        return undefined;
    }
    canAct(player) {
        const oceansMaxed = player.game.noOceansAvailable();
        const oceanCost = 12;
        const trGain = oceansMaxed ? 0 : 1;
        const redsAreRuling = PartyHooks_1.PartyHooks.shouldApplyPolicy(player, PartyName_1.PartyName.REDS);
        Card_1.Card.setRedsActionWarningText(player, trGain, this, redsAreRuling);
        if (oceansMaxed) {
            Card_1.Card.setUselessActionWarningText(this, 'all oceans have already been placed');
            return player.canAfford(oceanCost, { titanium: true });
        }
        if (redsAreRuling) {
            this.reserveUnits = Units_1.Units.adjustUnits(this.reserveUnits, { megacredits: constants_1.REDS_RULING_POLICY_COST });
            const actionDetails = this.getActionDetails();
            this.howToAffordReds = RedsPolicy_1.RedsPolicy.canAffordRedsPolicy(player, player.game, actionDetails, false, true);
            if (this.howToAffordReds.mustSpendAtMost !== undefined || this.howToAffordReds.bonusMCFromPlay !== undefined) {
                this.reserveUnits = Units_1.Units.maybeAdjustReservedMegacredits(player, this.reserveUnits, this.howToAffordReds);
            }
            return this.howToAffordReds.canAfford;
        }
        return player.canAfford(oceanCost, { titanium: true });
    }
    action(player) {
        player.game.defer(new SelectHowToPayDeferred_1.SelectHowToPayDeferred(player, 12, { canUseTitanium: true, title: 'Select how to pay for action', afterPay: () => {
                if (this.howToAffordReds !== undefined)
                    player.howToAffordReds = this.howToAffordReds;
                player.game.defer(new PlaceOceanTile_1.PlaceOceanTile(player));
            } }));
        return undefined;
    }
    getActionDetails() {
        return new RedsPolicy_1.ActionDetails({ cost: 12, oceansToPlace: 1 });
    }
}
exports.WaterImportFromEuropa = WaterImportFromEuropa;
//# sourceMappingURL=WaterImportFromEuropa.js.map